// extracted by mini-css-extract-plugin
module.exports = {"layout":"dialog-attachments_layout__3bNEz"};